import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    SelectField,
    ReferenceField,
    CardActions,
    CreateButton,
    FunctionField,
    DateField,
    BulkDeleteWithConfirmButton,
    DeleteWithConfirmButton
} from 'react-admin';
import Filter from './Filter';
import ProvisionActionButton from "../component/ProvisionActionButton";
import MedicalPrograms from "../helper/MedicalPrograms";

const translateForDeactivation = {
    AUTO_CONTRACT_TERMINATION: 'Деактивація якщо контракт деактивовано',
    AUTO_DIVISION_DEACTIVATION: 'Деактивація у випадку закриття підрозділу',
    AUTO_DIVISION_DLS_NOT_VERIFIED: 'Деактивація якщо підрозділ став неверифікованим у ДЛС',
    AUTO_LEGAL_ENTITY_DEACTIVATION: 'Деактивація у випадку закриття медичного закладу',
    AUTO_MEDICAL_PROGRAM_DEACTIVATION: 'Деактивація у випадку деактивації медичної програми',
    MANUAL_DEACTIVATION: 'Деактивація користувачем'
}

const ProvisionActions = ({
                             bulkActions,
                             basePath,
                             currentSort,
                             displayedFilters,
                             exporter,
                             filters,
                             filterValues,
                             onUnselectItems,
                             resource,
                             selectedIds,
                             showFilter,
                             total
                         }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        <CreateButton basePath={basePath} label={"Створити"} />
    </CardActions>
);

const BulkActionButtons = (props) => {
    return <>
        <BulkDeleteWithConfirmButton
            label="Деактивувати"
            confirmContent="Ви хочете видалити ці зобов'язання?"
            confirmTitle="Обережно!"
            selectedIds={props.selectedIds}
        />
    </>
};


export const ProvisionList = (props) => (
    <List {...props}
          filters={<Filter />}
          empty={false}
          bulkActionButtons={<BulkActionButtons {...props} />}
          className="list-styles"
          perPage={25}
          title="Зобов'язання"
          actions={<ProvisionActions/>}
    >
        <Datagrid  isRowSelectable={ record => record.isActive }>
            <TextField sortable={false} label="Номер контракту" source="contractNumber" />
            <SelectField sortable={false} label="Мед. програма" source="medicalProgramId" choices={MedicalPrograms} />
            <ReferenceField sortable={false} label="Аптека" source="divisionId" reference="divisions">
                <TextField source="name" />
            </ReferenceField>
            <DateField sortable={false} label="Додано" source="insertedAt" locales="uk-UA" />
            <DateField sortable={false} label="Змінено" source="updatedAt" locales="uk-UA" />
            <FunctionField
                label="Статус"
                render={record => record.isActive ? <div style={{color: '#009900'}}>АКТИВНА</div> : <div style={{color: '#ff0000'}}>НЕ АКТИВНА</div>}
            />
            <FunctionField
                label="Причина деактивації"
                render={record => record.deactivateReason ? translateForDeactivation[record.deactivateReason] || record.deactivateReason : ''}
            />

            <ProvisionActionButton/>
        </Datagrid>
    </List>
);

export default ProvisionList;
